<template>
	<md-dialog :md-active="show" style="font-family: 'Montserrat', sans-serif; z-index: 2000">
		<div style="width: 500px">
			<!-- Header -->
			<div class="dialog-header">
				<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">
					<strong>{{ $t("new-ticket") | capitalize }}</strong>
				</span>
				<div style="margin-left: auto; margin-right: 0">
					<md-button @click="$emit('close', false)" class="md-icon-button" style="margin-right: -5px">
						<md-icon style="color: white">close</md-icon>
					</md-button>
				</div>
			</div>

			<!-- Body -->
			<div class="dialog-body">
				<div class="container">
					<el-input
						v-model="form.title"
						:placeholder="$t('title') | capitalize"
						style="border: 1pt solid #ccc"
					></el-input>

					<el-select
						v-if="user && user.organization.id == '1'"
						v-model="form.organizationId"
						default-first-option
						filterable
						style="width: 100%"
					>
						<el-option
							v-for="school in schools"
							:key="school.id"
							:label="getSchoolNameFromOrganization(school)"
							:value="school.id"
						></el-option>
					</el-select>
				</div>
			</div>

			<!-- Footer -->
			<div class="dialog-footer">
				<div style="margin-left: auto; margin-right: 0">
					<md-button class="cancel" @click="$emit('close', false)">
						{{ $t("cancel") }}
					</md-button>

					<md-button class="add" @click="submit" :disabled="Object.values(form).some(val => !val)">
						<i class="el-icon-loading" v-if="loading" />
						<span>{{ $t("send") }}</span>
					</md-button>
				</div>
			</div>
		</div>
	</md-dialog>
</template>

<script>
import { filters, getSchoolNameFromOrganization } from "@/utils/utils"
import { mapActions, mapState } from "vuex"

export default {
	name: "add-ticket",
	mixins: [filters],
	props: {
		show: {
			type: Boolean,
			required: true
		},
		schools: {
			type: Array,
			required: false,
			default: () => []
		}
	},
	data: () => ({
		loading: false,
		form: {
			title: undefined,
			organizationId: undefined
		}
	}),
	computed: mapState("user", ["user"]),
	watch: {
		show(newValue) {
			if (!newValue) this.clearData()
		}
	},
	created() {
		this.form.organizationId = this.user.organization.id === "1" ? undefined : this.user.organization.id
	},
	methods: {
		getSchoolNameFromOrganization,
		...mapActions("ticketing", ["insertTicket"]),
		clearData() {
			this.loading = false
			this.form.title = undefined
			this.form.organizationId = undefined
		},
		submit() {
			this.loading = true
			this.insertTicket(this.form).finally(() => {
				this.clearData()
				this.$emit("close", true)
			})
		}
	}
}
</script>
